import {WB_EntityRow, WB_FinishedProductRow} from "../PA.Core/PAdbSchemaRows";
import {IHierarchyNodeProvider, INode, INodeLogicalKey} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {esWB_Finished_Product} from "../PA.Core/PAdbSchema";
import {CustomerNodeProvider} from "./CustomerNodeProvider";
import {ProductNodeProvider} from "./ProductNodeProvider";
import * as _ from "lodash";

export class ProductNode
    implements INode {
    private prodRow: WB_FinishedProductRow
    private prodProvider: ProductNodeProvider

    private bTypesLoaded: boolean
    private dctEntity: {[wbEntityId: number]: WB_EntityRow}

    constructor(prodRow: WB_FinishedProductRow, provider: ProductNodeProvider) {
        this.prodRow = prodRow
        this.prodProvider = provider

        this.bTypesLoaded = false
        this.dctEntity = {}
    }

    // Key
    get wbId(): number {
        return this.prodRow.cif.WB_PROD_ID
    }

    get provider(): IHierarchyNodeProvider {
        return this.prodProvider
    }



    // Logical Identity
    get id_ui(): string {
        return this.prodRow.cif.PRODUCT_ID
    }

    get key_set(): string {
        return this.prodRow.cif.PRODUCT_SET_ID
    }

    get bUseLogicalKey(): boolean {
        // TODO:  Update once we have created a LK type node
        return false
    }

    get logicalKey(): INodeLogicalKey {
        // TODO:  Update once we have created a LK type node
        return undefined
    }

    // Storage, needed to determine
    get mapperName(): string {
        return esWB_Finished_Product
    }

    // Other properties
    get node_name(): string {
        return this.prodRow.cif.PRODUCT_NAME
    }

    isEntityType(wbEntityId: number, opts?: { wbSalesAreaIds?: number[] }): boolean {
        this.checkTypesLoaded()

        if(_.isEmpty(opts?.wbSalesAreaIds))
            return (wbEntityId in this.dctEntity)

        return false;
    }

    get entityTypes(): WB_EntityRow[] {
        this.checkTypesLoaded()

        return _.values(this.dctEntity)
    }


    private checkTypesLoaded(){
        if(this.bTypesLoaded)
            return

        // Use provider to create Dictionaries
        let dct = _.keyBy(this.provider.entityTypes, (a) => a.cif.META_WB_ID)

        if(this.prodRow.cif.WB_PRDM_ID in dct){
            let entity = dct[this.prodRow.cif.WB_PRDM_ID]
            this.dctEntity[entity.cif.WB_ENTITY_ID] = entity
        }

        this.bTypesLoaded = true

    }




}